export default {
  'products.name': 'Món ăn',
  'products.create': 'Thêm món ăn',
  'products.update': 'Cập nhật món ăn',
  'products.information': 'Thông tin món ăn',
  'products.delete.title': 'Xóa món ăn',
  'products.delete.content':
    'Bạn có chắc xóa món ăn. Món ăn bị xóa sẽ không thể không phục',
  'products.productsName': 'Tên món ăn',
  'products.productsImage': 'Hình ảnh',
  'products.productsPrice': 'Giá món',
  'products.internalComment': 'Chi tiết',
  'products.add': 'Tạo sản phẩm',
  'products.back': 'Trở về',
};
